/**
 * Returns the date part of an ISO date string
 * 
 * @param {string} dateString - ISO string with YYYY-MM-DD pattern
 * @returns {string}
 */
export function getDatePartFromISO(dateString) {
  return dateString.slice(0, 10);
}

/**
 * Returns today's date formatted as 'YYYY-MM-DD'
 * @returns {string}
 */
export function getCurrentDateInISO() {
  const currentDate = new Date().toISOString();
  return getDatePartFromISO(currentDate);
}

/**
 * Returns a new ISO date string (YYYY-MM-DD) offset by a number of days
 * from the given ISO date string.
 * @param {string} isoDate - in format "YYYY-MM-DD"
 * @param {number} days
 * @returns {string} - new ISO date string
 */
export function addDays(isoDate, days) {
  const result = new Date(isoDate + 'T00:00:00Z');
  result.setUTCDate(result.getUTCDate() + days);
  return getDatePartFromISO(result.toISOString());
}

/**
 * Returns true if the date that is X days from today is before
 * the given end date. If no end date is provided, returns true.
 *
 * @param {number} daysFromToday - Number of days from today to check
 * @param {string|undefined} endDateISO - Optional end date in ISO format (YYYY-MM-DD)
 * @returns {boolean}
 */
export function isDaysFromTodayBeforeEndDate(daysFromToday, endDateISO) {
  if (!endDateISO) return true;

  const targetDate = addDays(getCurrentDateInISO(), daysFromToday);
  const endDate = getDatePartFromISO(endDateISO);

  return endDate > targetDate;
}